import { useState } from "react";
import { SelectXWitValidationProps } from "./types";
import Label from "./label";
import Select, { OptionsOrGroups } from "react-select"
import { useEffectOnce } from "../../../../lib-shared/src/hooks";
import { observer } from "mobx-react-lite";

const selectColumnCss = "selectx-col";


//TODO: Rename
//Select that uses ReactSelect but does not use react-hook-form
export const SelectZ = observer((props: SelectXWitValidationProps) => {

    const [hasValue, setHasValue] = useState(false);
    const [hasValidValue, setHasValidValue] = useState(true);

    const {
        name,
        options,
        label,
        labelCssName = "",
        // usePlaceholder = false,
        placeHolder,
        isClearable = false,
        errorMessage,
        isValid
    } = props;


    let cssName = props.cssName ?? "";

    const handleValueChange = (option: any) => {
        setHasValue(option && option.value !== "");

        if (!!isValid) {
            const isValueValid = isValid(option?.value);
            setHasValidValue(isValueValid);
        }

        if (!!props.onChange) {
            props.onChange(option?.value);
        }
    }

    const usePlaceholder = true;

    if (!cssName.includes(selectColumnCss)) {
        cssName += ` ${selectColumnCss}`;
    }

    const cssForLabel = labelCssName + (usePlaceholder ? (hasValue ? " visible" : " hidden") : "");
    const placeholderText = usePlaceholder
        ? placeHolder ?? label
        : "";

    const selectOptions = options as OptionsOrGroups<any, any>;
    const defaultValue = props?.defaultValue;

    useEffectOnce(() => {
        if (defaultValue) {
            setHasValue(true);
        }
    });

    return (<div className={cssName}>
        <Label htmlFor={name} cssName={cssForLabel} text={label} />

        <Select
            id={name}
            className="react-select-container"
            classNamePrefix="react-select"
            defaultValue={defaultValue}
            placeholder={placeholderText}
            isClearable={isClearable}
            isSearchable={false}
            onChange={handleValueChange}
            styles={{
                control: (baseStyles, state) => ({
                    ...baseStyles,
                    border: 0,
                    borderBottom: "1px solid #ccc",
                    borderRadius: 0,
                    boxShadow: "none"
                }),
                indicatorSeparator: (base, props) => ({
                    display: "none"
                }),
                menu: (baseStyles, state) => ({
                    ...baseStyles,
                    borderRadius: 0
                }),
                menuList: (baseStyles, state) => ({
                    ...baseStyles,
                    boxShadow: "0 0 5px rgba(0,0,0,.3)",
                    borderRadius: 0
                }),
                option: (baseStyles, state) => ({
                    color: "#00aeef",
                    fontSize: "11px",
                    padding: "15px 20px",
                    borderRadius: 0,
                    cursor: "pointer",
                    ":hover": {
                        backgroundColor: "rgba(10,18,29,.051)",
                        fontWeight: 600
                    }
                })
            }}
            options={selectOptions} />


        {!hasValidValue && <p className="error">{errorMessage}</p>}
    </div>);
});

export default SelectZ;